// extracted by mini-css-extract-plugin
module.exports = {"modal":"GuestCustomerOnboardingModal_modal__ysYSm","infoText":"GuestCustomerOnboardingModal_infoText__t5X_R"};